// extracted by mini-css-extract-plugin
export default {"admin":"Admin-module__admin__BRQW4","action":"Admin-module__action__cgmT+","icon":"Admin-module__icon__6N0E3"};